var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header"},[_c('span',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.mainTitle))]),_c('div',{staticClass:"btn-list"},[_vm._t("btn")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }